import {useState} from 'react';

export const useIsHorizontalScrolling = (): {
  isHorizontalScrolling: boolean;
  onScroll: (e: React.UIEvent<HTMLDivElement, UIEvent>) => void;
} => {
  const [isHorizontalScrolling, setIsHorizontalScrolling] = useState(false);

  const onScroll = (e: React.UIEvent<HTMLDivElement, UIEvent>) => {
    const {scrollLeft} = e.currentTarget;

    if (scrollLeft > 0 && !isHorizontalScrolling) setIsHorizontalScrolling(true);
    if (scrollLeft === 0 && isHorizontalScrolling) setIsHorizontalScrolling(false);
  };

  return {isHorizontalScrolling, onScroll};
};

export const useScrollEdges = (): {
  scrollEdges: 'left' | 'both' | 'right';
  onScroll: (e: React.UIEvent<HTMLDivElement, UIEvent>) => void;
} => {
  const [scrollEdges, setScrollEdges] = useState<'left' | 'both' | 'right'>('left');

  const onScroll = (e: React.UIEvent<HTMLDivElement, UIEvent>) => {
    const {scrollLeft, scrollWidth, clientWidth} = e.currentTarget;

    if (scrollLeft === 0 && scrollEdges !== 'left') {
      setScrollEdges('left');
      return;
    }
    if (scrollLeft > 0 && scrollLeft < scrollWidth - clientWidth && scrollEdges !== 'both') {
      setScrollEdges('both');
      return;
    }
    if (scrollLeft >= scrollWidth - clientWidth - 1 && scrollEdges !== 'right') {
      setScrollEdges('right');
      return;
    }
  };

  return {scrollEdges: scrollEdges, onScroll};
};
